import { createContext, useContext } from 'react'

/** What the page header downloads: the chart as a PNG or its data as a CSV. */
export interface ChartDownload {
  png: () => void
  csv: () => void
}

interface DashboardDownloadContextProps {
  /** Undefined until a chart is on the page. */
  download?: ChartDownload
  setDownload: (download?: ChartDownload) => void
}

export const DashboardDownloadContext = createContext<DashboardDownloadContextProps | undefined>(
  undefined
)

/** Undefined outside the provider. A chart outside it has no header to download from. */
export const useDashboardDownload = () => useContext(DashboardDownloadContext)
